<template>
    <div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    height="100%"
                    row-key="id"
                    :data="intoRecordList.beanList">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="投入金豆数量" align="center" prop="amount">
                  <template slot-scope="scope">{{scope.row.amount|numberChip }}</template>
                </el-table-column>
                <el-table-column label="俱乐部" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                <el-table-column label="盲注级别" align="center" prop="blindName">
                  <template slot-scope="scope">{{scope.row.blindName|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="投入时间" align="center" prop="createdTime">
                    <template slot-scope="scope">{{scope.row.createdTime | toTime}}</template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="intoRecordList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('jpbAccount', ['intoRecordList'])
        },
        methods: {
            ...mapActions('jpbAccount', ['getIntoRecordList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getIntoRecordList(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>